import axios from 'axios'
import {getCookie} from "./utils";

let baseUrl = process.env.VUE_APP_LAMBDA_BASE_URL;

let apiUrls = {
    getUnitList: 'accounts/unit',
    getUnit: 'accounts/unit/{key}/',
    createUnit: 'accounts/unit/create',
    login: 'accounts/login',
    createUser: 'accounts/user/createcandidate',
    createAdminUser: 'accounts/admin/create',
    createInstitutionUser: 'accounts/user/create',
    checkUserExistenceByEmail: 'accounts/user/email',
    forgotPassword: 'accounts/forgot-password',
    resetPassword: 'accounts/password-reset',
    getUser: 'accounts/user/{key}',
    getUsers: 'accounts/user',
    updateUser: 'accounts/user/{key}/update',
    setUserStatus: 'accounts/user/{key}/set-status',

    createRecipient: 'billing/recipient/create',
    getRecipient: 'billing/recipient',

    getAreaList: 'processes/area/',
    getAreaForProcessList: 'processes/selectionprocess/{key}/areas',
    getProcessList: 'processes/selectionprocess',
    createArea: 'processes/area/create/',
    getCourseTypeList: 'processes/course_type/',
    getCourseTypeForProcessList: 'processes/selectionprocess/{key}/coursetypes',
    createCourseType: 'processes/course_type/create/',
    getCourseList: 'processes/course/',
    getCourse: 'processes/course/{key}/',
    createCourse: 'processes/course/create/',
    getPlaceList: 'processes/place/',
    createPlace: 'processes/place/create/',
    batchCreatePlace: 'processes/place/batchcreate/',
    copySelectionProcess: 'processes/selectionprocess/{key}/copy',
    pauseSelectionProcess: 'processes/selectionprocess/{key}/pause',
    resumeSelectionProcess: 'processes/selectionprocess/{key}/resume',
    publishSelectionProcess: 'processes/selectionprocess/{key}/publish',
    deleteSelectionProcess: 'processes/selectionprocess/{key}/delete',
    getResult: 'processes/selectionprocess/{key}/results',
    getSelectionProcess: 'processes/selectionprocess/{key}',
    saveSelectionProcessDraft: 'processes/selectionprocess/draft',
    sendProcessEmail: 'processes/sendprocessemail',
    uploadUserFileS3: 'processes/upload/userfiles/',
    uploadNoticeS3: 'processes/upload/notice/',
    uploadBannerS3: 'processes/upload/banner/',

    getSubscriptionForm: 'subscriptions/form/{key}',
    getSubscriptionsList: 'subscriptions/subscription/',
    getCandidateSubscriptionsList: 'subscriptions/subscription/candidate',
    postSubscriptionForm: 'subscriptions/form/post',
    uploadCandidateFileS3: 'subscriptions/upload/candidatefile',
    getTotalSubscriptions: 'subscriptions/subscription/total/{key}',
    getSubscriptionsFile: 'subscriptions/download',
    getClassificationFile: 'subscriptions/classification-report/{key}',
    cancelSubscription: 'subscriptions/cancel/{key}',
    cancelSubscriptions: 'subscriptions/cancel-admin',
    postSendEmail: 'subscriptions/sendsubscriptionemail/',
    getBackupFile: 'subscriptions/backup/{slug}/',
    postSubscriptionAppeal: 'subscriptions/appeal/{key}',
    postReplacePayment: 'billing/payment/replace',
};

export function downloadBase64(base64Data, fileName, fileType) {
    let a = document.createElement("a");
    a.href = "data:" + fileType + ";base64," + base64Data;
    a.download = fileName;
    a.click();
}

export function download(url, fileName, fileType) {
    let a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.${fileType}`;
    a.click();
}

export function getBase64(file, callback) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        callback(reader.result);
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}

export function postRequest(api, data, pathParams, extraHeaders) {
    let options = {
        headers: {"Content-Type": "application/json"}
    };

    let url = apiUrls[api];

    if (pathParams) {
        for (let [key, value] of Object.entries(pathParams)) {
            url = url.replace("{" + key + "}", value);
        }
    }

    if (extraHeaders) {
        for (let [key, value] of Object.entries(extraHeaders)) {
            options.headers[key] = value;
        }
    }

    if (getCookie('authToken')) {
        options.headers.Authorization = getCookie('authToken')
    }

    return axios.post(baseUrl + url, data, options)
}

export function getRequest(api, pathParams, queryParams, extraHeaders) {
    let url = apiUrls[api];

    if (pathParams) {
        for (let [key, value] of Object.entries(pathParams)) {
            url = url.replace("{" + key + "}", value);
        }
    }

    if (queryParams) {
        let prefix = '?';
        for (let [key, value] of Object.entries(queryParams)) {
            url = url + prefix + key + '=' + value;
            prefix = '&';
        }
    }

    let options = {};

    if (extraHeaders) {
        for (let [key, value] of Object.entries(extraHeaders)) {
            options.headers[key] = value;
        }
    }

    if (getCookie('authToken')) {
        options.headers = {Authorization: getCookie('authToken')}
    }

    return axios.get(baseUrl + url, options)
}
